/**
 * Brand-logo path helper.
 *
 * The former per-security SVG-logo system (a hand-maintained ticker→file
 * allow-list, the UK-ticker→logo map, and fund-provider detection) was demo
 * residue (ADR-0005) and is gone — security identity now comes from the real
 * OpenFIGI-backed `security_reference` cache and renders as a monogram via
 * `CompanyLogo`. This module retains only the Septima brand-logo path used in
 * the sidebar, mobile top bar, dashboard shell and the auth screens.
 */

/** Path to the Septima brand logo. */
export function getSeptimaLogoPath(): string {
    return '/logos/septima.svg';
}

/**
 * Theme-aware path to the Septima icon mark. The asset files are pre-coloured
 * (black on `light`, white on `dark`) rather than recoloured via CSS `invert`,
 * so the caller passes the resolved theme and gets the correctly-filled file.
 */
export function getSeptimaMarkPath(resolvedTheme: 'light' | 'dark'): string {
    return resolvedTheme === 'dark'
        ? '/logos/septima-mark-dark.svg'
        : '/logos/septima-mark-light.svg';
}

/**
 * Theme-aware path to the full Septima wordmark (icon + lettering). Same
 * pre-coloured convention as {@link getSeptimaMarkPath}.
 */
export function getSeptimaWordmarkPath(resolvedTheme: 'light' | 'dark'): string {
    return resolvedTheme === 'dark'
        ? '/logos/septima-wordmark-dark.svg'
        : '/logos/septima-wordmark-light.svg';
}
